export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL';
export const UPDATE_DEFAULT_MESSAGE_REQUEST = 'UPDATE_DEFAULT_MESSAGE_REQUEST';
export const UPDATE_WEBHOOK = 'UPDATE_WEBHOOK';
export const UPDATE_REQUEST_NUMBER = 'UPDATE_REQUEST_NUMBER';
export const INCREASE_REQUEST_NUMBER = 'INCREASE_REQUEST_NUMBER';
export const DECREASE_REQUEST_NUMBER = 'DECREASE_REQUEST_NUMBER';
export const UPDATE_TEST_MODE = 'UPDATE_TEST_MODE';
